(() => {
  'use strict';
  const $ = (selector, root = document) => root.querySelector(selector);
  const $$ = (selector, root = document) => [...root.querySelectorAll(selector)];
  const rootConfig = window.DERVEMONT || {};
  let activeCurrency = rootConfig.currency || 'EUR';

  const money = (cents) => {
    const value = Number(cents || 0) / 100;
    try {
      return new Intl.NumberFormat(document.documentElement.lang || 'en-IE', { style: 'currency', currency: activeCurrency }).format(value);
    } catch (_) {
      return `${activeCurrency} ${value.toFixed(2)}`;
    }
  };

  const announce = (message) => {
    const node = $('#announcement');
    if (!node) return;
    node.textContent = '';
    window.setTimeout(() => { node.textContent = message; }, 20);
  };

  const openDialog = (selector) => {
    const dialog = $(selector);
    if (dialog && !dialog.open && typeof dialog.showModal === 'function') dialog.showModal();
  };

  const closeDialogs = () => {
    $$('dialog[open]').forEach((dialog) => dialog.close());
  };

  const setBagCount = (count) => {
    const countNode = $('.bag-count');
    const bagButton = $('.bag-button');
    if (countNode) countNode.textContent = String(count || 0);
    if (bagButton) bagButton.setAttribute('aria-label', `Open shopping bag, ${count || 0} items`);
  };

  const cartRoutes = {
    cart: rootConfig.routes?.cart || '/cart.js',
    add: rootConfig.routes?.add || '/cart/add.js',
    change: rootConfig.routes?.change || '/cart/change.js',
    checkout: rootConfig.routes?.checkout || '/checkout'
  };

  async function getCart() {
    const response = await fetch(cartRoutes.cart, { headers: { Accept: 'application/json' } });
    if (!response.ok) throw new Error('Unable to load the shopping bag.');
    const cart = await response.json();
    if (cart.currency) activeCurrency = cart.currency;
    setBagCount(cart.item_count);
    return cart;
  }

  function bagImage(item) {
    if (!item.image) return '<div class="bag-image-placeholder" aria-hidden="true"></div>';
    const alt = `${item.product_title || item.title || 'Product'}${item.variant_title ? ` — ${item.variant_title}` : ''}`;
    return `<img src="${item.image}" alt="${escapeHtml(alt)}">`;
  }

  function escapeHtml(value) {
    return String(value ?? '').replace(/[&<>'"]/g, (char) => ({ '&':'&amp;', '<':'&lt;', '>':'&gt;', "'":'&#39;', '"':'&quot;' }[char]));
  }

  async function renderBag() {
    const dialog = $('#bag-dialog');
    if (!dialog) return;
    dialog.innerHTML = '<div class="dialog-heading"><div><div class="eyebrow">YOUR SELECTION</div><h2 id="bag-title">The shopping bag</h2></div><button class="close" data-close aria-label="Close shopping bag">×</button></div><div class="empty-bag"><p>Loading your selection…</p></div>';
    try {
      const cart = await getCart();
      const count = cart.item_count || 0;
      dialog.innerHTML = `<div class="dialog-heading"><div><div class="eyebrow">YOUR SELECTION</div><h2 id="bag-title">The shopping bag <small>(${count})</small></h2></div><button class="close" data-close aria-label="Close shopping bag">×</button></div>` +
        (count === 0
          ? `<div class="empty-bag"><svg viewBox="0 0 24 24"><path d="M5 7h14l1 14H4L5 7ZM8 7V5a4 4 0 0 1 8 0v2"/></svg><h3>A little room for possibility.</h3><p>Your bag is waiting for something considered.</p><a class="button" href="/products/the-sovereign-knit" data-dismiss>Discover the knit <span class="ui-arrow" aria-hidden="true"></span></a></div>`
          : `<div class="bag-items">${cart.items.map((item, index) => {
              const variantText = item.variant_title && item.variant_title !== 'Default Title' ? item.variant_title : '';
              return `<article class="bag-item">${bagImage(item)}<div><div class="bag-line-top"><h3><a href="${item.url}" data-dismiss>${escapeHtml(item.product_title || item.title)}</a></h3><span class="bag-line-price">${money(item.final_line_price)}</span></div><p>${escapeHtml(variantText)}</p><div class="bag-line-bottom"><div class="quantity" aria-label="Bag quantity"><button type="button" data-cart-line="${index + 1}" data-cart-qty="${Math.max(0, item.quantity - 1)}" aria-label="Decrease quantity">−</button><output>${item.quantity}</output><button type="button" data-cart-line="${index + 1}" data-cart-qty="${item.quantity + 1}" aria-label="Increase quantity">+</button></div><button type="button" class="remove" data-cart-line="${index + 1}" data-cart-qty="0">Remove</button></div></div></article>`;
            }).join('')}</div><div class="bag-footer"><div class="bag-total"><span>Subtotal</span><span>${money(cart.total_price)}</span></div><p>Shipping and taxes are calculated at checkout.</p><button type="button" class="button" data-action="checkout">Checkout <span><span class="ui-arrow" aria-hidden="true"></span></span></button><button type="button" class="continue" data-close>Continue exploring</button></div>`);
    } catch (error) {
      dialog.insertAdjacentHTML('beforeend', `<div class="bag-error">${escapeHtml(error.message)}</div>`);
    }
  }

  async function changeCart(line, quantity) {
    const response = await fetch(cartRoutes.change, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ line: Number(line), quantity: Math.max(0, Number(quantity)) })
    });
    if (!response.ok) throw new Error('Unable to update the shopping bag.');
    await renderBag();
  }

  function productRoot() {
    return $('[data-product-root]');
  }

  function getVariantData(root) {
    const section = root.closest('.shopify-section') || root.parentElement;
    const node = $('[data-product-variants]', root) || (section ? $('[data-product-variants]', section) : null) || $('[data-product-variants]');
    if (!node) return [];
    try { return JSON.parse(node.textContent); } catch (_) { return []; }
  }

  function selectedOptions(root) {
    const groups = $$('[data-option-index]', root).filter((element, index, array) => array.findIndex((item) => item.dataset.optionIndex === element.dataset.optionIndex) === index);
    return groups.sort((a,b) => Number(a.dataset.optionIndex) - Number(b.dataset.optionIndex)).map((group) => {
      const active = $(`[data-option-value][data-option-index="${group.dataset.optionIndex}"][aria-pressed="true"]`, root);
      return active ? active.dataset.optionValue : '';
    });
  }

  function syncVariant(root) {
    const variants = getVariantData(root);
    const options = selectedOptions(root);
    const variant = variants.find((item) => Array.isArray(item.options) && item.options.every((value, index) => value === options[index]));
    const variantInput = $('[data-variant-id]', root);
    const addButton = $('[data-action="add"]', root);
    const price = $('[data-product-price]', root);
    const availability = $('[data-availability]', root);
    if (!variant) {
      if (addButton) addButton.disabled = true;
      if (availability) availability.textContent = 'This option combination is unavailable';
      return;
    }
    if (variantInput) variantInput.value = variant.id;
    if (price) price.textContent = money(variant.price);
    if (addButton) addButton.disabled = !variant.available;
    if (availability) availability.textContent = variant.available ? 'Available now' : 'Currently unavailable';
    let mediaThumb = null;
    if (variant.featured_media_id) {
      mediaThumb = $(`[data-gallery-index][data-media-id="${variant.featured_media_id}"]`, root);
    }
    if (!mediaThumb && variant.featured_media_src) {
      mediaThumb = $$('[data-gallery-index]', root).find((thumb) => thumb.dataset.src === variant.featured_media_src) || null;
    }
    if (!mediaThumb) {
      const activeColor = $('.swatches [data-option-value][aria-pressed="true"]', root);
      const colorName = activeColor?.dataset.optionValue?.trim().toLowerCase();
      if (colorName) {
        mediaThumb = $$('[data-gallery-index]', root).find((thumb) => (thumb.dataset.alt || '').toLowerCase().includes(colorName)) || null;
      }
    }
    if (mediaThumb) {
      selectGalleryImage(root, Number(mediaThumb.dataset.galleryIndex));
      root.dataset.currentMediaId = mediaThumb.dataset.mediaId || String(variant.featured_media_id || '');
    } else if (variant.featured_media_src) {
      const main = $('#product-image', root);
      if (main) {
        main.src = variant.featured_media_src;
        main.alt = variant.featured_media_alt || main.alt;
      }
      if (variant.featured_media_id) root.dataset.currentMediaId = String(variant.featured_media_id);
    }
    const url = new URL(window.location.href);
    url.searchParams.set('variant', variant.id);
    window.history.replaceState({}, '', url);
  }

  function updateQuantity(root, delta) {
    const input = $('[data-quantity-input]', root);
    const output = $('[data-quantity-output]', root);
    if (!input || !output) return;
    const next = Math.max(1, Math.min(99, Number(input.value || 1) + delta));
    input.value = String(next);
    output.textContent = String(next);
    const minus = $('[data-action="qty-minus"]', root);
    if (minus) minus.disabled = next <= 1;
  }

  function selectGalleryImage(root, index) {
    const thumbs = $$('[data-gallery-index]', root);
    const thumb = thumbs.find((item) => Number(item.dataset.galleryIndex) === Number(index));
    const main = $('#product-image', root);
    if (!thumb || !main) return;
    main.src = thumb.dataset.src;
    main.alt = thumb.dataset.alt || '';
    root.dataset.galleryIndex = String(index);
    thumbs.forEach((item) => item.setAttribute('aria-pressed', item === thumb ? 'true' : 'false'));
    const number = $('.image-number', root);
    if (number) number.textContent = `${String(Number(index) + 1).padStart(2,'0')} / ${String(thumbs.length).padStart(2,'0')}`;
    const caption = $('.gallery-caption', root);
    if (caption) caption.textContent = `${thumb.dataset.alt || 'Product image'} · Select an image to explore. Click to enlarge.`;
  }

  function renderZoom() {
    const root = productRoot();
    const dialog = $('#gallery-dialog');
    if (!root || !dialog) return;
    const thumbs = $$('[data-gallery-index]', root);
    if (!thumbs.length) return;
    const currentIndex = Math.max(0, Math.min(thumbs.length - 1, Number(root.dataset.galleryIndex || 0)));
    const thumb = thumbs[currentIndex];
    dialog.innerHTML = `<button type="button" class="close" data-close aria-label="Close enlarged gallery">×</button><img class="large-image" src="${thumb.dataset.src}" alt="${escapeHtml(thumb.dataset.alt || '')}"><div class="gallery-controls"><button type="button" data-action="image-prev" aria-label="Previous image">←</button><span aria-live="polite">${escapeHtml(thumb.dataset.alt || 'Product image')} &nbsp; ${currentIndex + 1} / ${thumbs.length}</span><button type="button" data-action="image-next" aria-label="Next image">→</button></div>`;
  }

  function moveGallery(delta) {
    const root = productRoot();
    if (!root) return;
    const thumbs = $$('[data-gallery-index]', root);
    if (!thumbs.length) return;
    const current = Number(root.dataset.galleryIndex || 0);
    const next = (current + delta + thumbs.length) % thumbs.length;
    selectGalleryImage(root, next);
    renderZoom();
  }

  function info(title, body) {
    const dialog = $('#info-dialog');
    if (!dialog) return;
    dialog.innerHTML = `<div class="dialog-heading"><h2 id="info-title">${escapeHtml(title)}</h2><button type="button" class="close" data-close aria-label="Close ${escapeHtml(title.toLowerCase())}">×</button></div><div class="info-body">${body}</div>`;
    openDialog('#info-dialog');
  }

  document.addEventListener('click', async (event) => {
    const target = event.target.closest('button,a');
    if (!target) return;

    if (target.hasAttribute('data-close')) {
      const dialog = target.closest('dialog');
      if (dialog) dialog.close();
      return;
    }
    if (target.hasAttribute('data-dismiss')) closeDialogs();

    if (target.dataset.optionValue !== undefined) {
      event.preventDefault();
      const root = target.closest('[data-product-root]');
      const index = target.dataset.optionIndex;
      $$(`[data-option-value][data-option-index="${index}"]`, root).forEach((button) => button.setAttribute('aria-pressed', button === target ? 'true' : 'false'));
      const label = $(`[data-option-label="${index}"]`, root);
      if (label) label.textContent = target.dataset.optionValue;
      const error = $('.size-error', root);
      if (error) error.textContent = '';
      syncVariant(root);
      return;
    }

    if (target.dataset.galleryIndex !== undefined) {
      event.preventDefault();
      selectGalleryImage(target.closest('[data-product-root]'), Number(target.dataset.galleryIndex));
      return;
    }

    if (target.dataset.cartLine !== undefined) {
      event.preventDefault();
      try { await changeCart(target.dataset.cartLine, target.dataset.cartQty); announce('Shopping bag updated.'); }
      catch (error) { announce(error.message); }
      return;
    }

    switch (target.dataset.action) {
      case 'menu': openDialog('#menu-dialog'); break;
      case 'bag': await renderBag(); openDialog('#bag-dialog'); break;
      case 'qty-minus': updateQuantity(target.closest('[data-product-root]'), -1); break;
      case 'qty-plus': updateQuantity(target.closest('[data-product-root]'), 1); break;
      case 'zoom': renderZoom(); openDialog('#gallery-dialog'); break;
      case 'image-prev': moveGallery(-1); break;
      case 'image-next': moveGallery(1); break;
      case 'checkout': window.location.href = cartRoutes.checkout; break;
      case 'size-guide': {
        const root = target.closest('[data-product-root]');
        const values = $$('[data-size-value]', root).map((el) => el.dataset.sizeValue);
        info('Size guide', `<div class="eyebrow">FIND YOUR PREFERRED FIT</div><p>Available sizes for this product are shown below. Final garment measurements should be added from the approved supplier size chart.</p><div class="measurement-list">${values.map((size) => `<div><span>Size ${escapeHtml(size)}</span><span>Measurements to be confirmed</span></div>`).join('')}</div>`);
        break;
      }
      case 'about': {
        const title = target.dataset.aboutTitle || 'About DERVEMONT';
        const eyebrow = target.dataset.aboutEyebrow || 'THE DERVEMONT PERSPECTIVE';
        const body = target.dataset.aboutBody || 'DERVEMONT is built around understated design, considered details and a quieter approach to modern menswear. Timeless pieces created to feel effortless, confident and distinctly your own.';
        info(escapeHtml(title), `<div class="eyebrow">${escapeHtml(eyebrow)}</div><p>${escapeHtml(body).replace(/\n/g, '<br>')}</p>`);
        break;
      }
      case 'care': {
        const title = target.dataset.careTitle || 'Product & care notes';
        const body = target.dataset.careBody || 'Product-specific details are shown on each product page. Follow the garment care label and approved supplier guidance for final customer-facing care instructions.';
        info(escapeHtml(title), `<p>${escapeHtml(body).replace(/\n/g, '<br>')}</p>`);
        break;
      }
    }
  });

  document.addEventListener('submit', async (event) => {
    const form = event.target;
    if (!(form instanceof HTMLFormElement) || !form.closest('[data-product-form]')) return;
    event.preventDefault();
    const root = form.closest('[data-product-root]');
    const button = $('[data-action="add"]', form);
    const error = $('.size-error', root);
    if (error) error.textContent = '';
    if (!button || button.disabled) return;
    button.classList.add('is-loading');
    button.disabled = true;
    try {
      const response = await fetch(cartRoutes.add, { method: 'POST', headers: { Accept: 'application/json' }, body: new FormData(form) });
      if (!response.ok) {
        const payload = await response.json().catch(() => ({}));
        throw new Error(payload.description || payload.message || 'Unable to add this item to your bag.');
      }
      await renderBag();
      openDialog('#bag-dialog');
      announce('Added to your shopping bag.');
    } catch (err) {
      if (error) error.textContent = err.message;
      announce(err.message);
    } finally {
      button.classList.remove('is-loading');
      syncVariant(root);
    }
  });

  document.addEventListener('click', (event) => {
    if (event.target instanceof HTMLDialogElement) {
      const rect = event.target.getBoundingClientRect();
      if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) event.target.close();
    }
  });

  document.addEventListener('keydown', (event) => {
    const gallery = $('#gallery-dialog');
    if (gallery?.open && (event.key === 'ArrowLeft' || event.key === 'ArrowRight')) {
      event.preventDefault();
      moveGallery(event.key === 'ArrowRight' ? 1 : -1);
    }
  });

  $$('[data-product-root]').forEach((root) => {
    const currentMediaId = root.dataset.currentMediaId;
    const initialThumb = currentMediaId ? $(`[data-gallery-index][data-media-id="${currentMediaId}"]`, root) : null;
    if (initialThumb) selectGalleryImage(root, Number(initialThumb.dataset.galleryIndex));
    else {
      const firstThumb = $('[data-gallery-index="0"]', root);
      if (firstThumb) selectGalleryImage(root, 0);
    }
    syncVariant(root);
  });
})();
